<div class="flex justify-center w-full">
  <div class="flex flex-col gap-6 px-8">

    <div [formGroup]="construct" class="flex flex-col gap-6">
      <div class="flex flex-col gap-1">
        <label for="exam_title" class="block font-medium leading-6 text-gray-900">
          {{is_classroom? 'Assessment title' : 'Exam title'}}
          <b class="text-red-600">*</b>
        </label>
        <input type="text" id="exam_title" placeholder="Enter Title" formControlName="exam_title" class="block rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6" />
        @if (construct.get('exam_title')?.invalid && construct.get('exam_title')?.touched) {
          <div>
            @if (construct.get('exam_title')?.errors?.['required']) {
              <b class="text-xs text-exam-red">Exam title is required. Please enter a title for the exam.</b>
            }
          </div>
        }
        <!--<div class="text-sm flex gap-1">
          <mat-checkbox formControlName="late_start" [checked]="construct.get('late_start')?.value">
            <mat-label>Can the student start the exam late?</mat-label>
          </mat-checkbox>
          <mat-checkbox formControlName="late_finish" [checked]="construct.get('late_finish')?.value">
            <mat-label>Can the student finish the exam late?</mat-label>
          </mat-checkbox>
        </div>-->
      </div>

      <!-- TODO re-add this once we are ready for create assessnent for classroom -->
      @if(is_classroom) {
        <div class="flex flex-col gap-1">
          <label for="assessment_type" class="block font-medium leading-6 text-gray-900">
            Assessment Type
            <b class="text-red-600">*</b>
          </label>
          <select
            #typeSelect
            type="select"
            formControlName="type"
            id="type"
            (change)="onTypeChange(typeSelect.value)"
            class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
            <option value="null" disabled [selected]="construct.get('type') == null || construct.get('type')?.getRawValue()?.toString() === ''">Select a type</option>
            <option [value]="assessmentTypes.exam" [selected]="construct.get('type')?.getRawValue()?.toString() === assessmentTypes.exam">
              Exam
            </option>
            <option [value]="assessmentTypes.quiz" [selected]="construct.get('type')?.getRawValue()?.toString() === assessmentTypes.quiz">
              Quiz
            </option>
            <option [value]="assessmentTypes.homework" [selected]="construct.get('type')?.getRawValue()?.toString() === assessmentTypes.homework">
              Homework
            </option>
          </select>
        </div>
      }

    <!-- <h2 class="font-semibold">Assign to Exam</h2> -->
    <div class="flex flex-col gap-1">
      <label for="course_id" class="block font-medium leading-6 text-gray-900">
        Course
        <b class="text-red-600">*</b>
      </label>
      <p class="text-[#8B96A2] text-sm">
        Only students enrolled in the course will be allowed to take the exam.
      </p>
      <select
        #courseSelect
        type="select"
        formControlName="course_id"
        id="course_id"
        (change)="onCourseChange(Number(courseSelect.value))"
        class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
        <option value="null" disabled [selected]="construct.get('course_id') == null || Number(construct.get('course_id')) === 0">Select a course</option>
        @for (course of courses; track course) {
          <option [value]="course.course_id" [selected]="Number(construct.get('course_id')) === course.course_id">
            {{course.name}}
          </option>
        }
      </select>
      @if (construct.get('course_id')?.invalid && construct.get('course_id')?.touched) {
        <div>
          @if (construct.get('course_id')?.errors?.['required']) {
            <b class="text-xs text-exam-red">Course is required. Please select an option.</b>
          }
        </div>
      }
    </div>
  </div>

  <div [formGroup]="assignFormSection">
    <section formArrayName="timeframes" class="flex flex-col gap-2">

      @for (timeframeForm of timeframes.controls; track timeframeForm; let index = $index) {
        <div [formGroupName]="index">
          <div class="flex flex-col gap-1">
            <label for="timeframe-{{index}}-subsection-id"class="block font-medium leading-6 text-gray-900">
              Subsection <b class="text-red-600">*</b>
            </label>
            <select type="select" formControlName="subsection_id" id="timeframe-{{index}}-subsection-id"
              class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
              <option value="null" disabled selected>Select a subsection</option>
              @for (subsection of subsections; track subsection) {
                <option [value]="subsection.subsection_id">
                  {{subsection.name}}
                </option>
              }
            </select>
            @if (timeframeForm.get('subsection_id')?.invalid && timeframeForm.get('subsection_id')?.touched) {
              <div>
                @if (timeframeForm.get('subsection_id')?.errors?.['required']) {
                  <b class="text-xs text-exam-red">Subsection is required. Please select an option.</b>
                }
              </div>
            }
          </div>

          <div class="flex flex-col gap-1 mt-6">
            <label for="course_id" class="block font-medium leading-6 text-gray-900">
              Max Attempts
              <b class="text-red-600">*</b>
            </label>
            <p class="text-[#8B96A2] text-sm">
              Select how many attempts the student can have. Default is only 1 attempt.
            </p>
            <input
              class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
              type="number"
              [formControl]="attemptsMaxControl"
              min="1"
              step="1"
            />
          </div>
          @if (examAdmin) {
            <div class="flex flex-col gap-2 mt-6">
              <h2 class="font-medium">Timeframe</h2>
              <div class="flex gap-2">
                <div>
                  <label for="timeframe-{{index}}-first" class="block text-sm leading-6 text-gray-900">
                    First Start:
                  </label>
                  <input type="datetime-local" [ngModel]="timeframeForm.get('first_start')?.value | date: 'yyyy-MM-ddTHH:mm'" formControlName="first_start" id="timeframe-{{index}}-first"
                    class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
                  </div>
                  <div>
                    <label for="exam-subsection-{{index}}-last-start"
                      class="block text-sm leading-6 text-gray-900">Last
                    Start: </label>
                    <input type="datetime-local" [ngModel]="timeframeForm.get('last_start')?.value | date: 'yyyy-MM-ddTHH:mm'" formControlName="last_start" id="exam-subsection-{{index}}-last-start"
                      class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
                    </div>
                    <div>
                      <label for="exam-subsection-{{index}}-finish"
                        class="block text-sm leading-6 text-gray-900">Finish
                      By: </label>
                      <input type="datetime-local" [ngModel]="timeframeForm.get('finish_by')?.value | date: 'yyyy-MM-ddTHH:mm'" [min]="currentDateTime" formControlName="finish_by" id="exam-subsection-{{index}}-finish"
                        class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </section>
        </div>
      </div>
</div>
